/* eslint-disable array-callback-return */
import Message from '../message';

/**
 * Create the action
 */

const { thunk, request, success, error } = Message.update(
  ({ messageId }, fetch) => fetch.patch(`/messages/${messageId}?delete`)
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
